import { composeIO } from 'react-compose-io'
import { semOcorrenciaInadimplenciaIO } from './SemOcorrenciaInadimplencia.IO'
import { SemOcorrenciaInadimplenciaView } from './SemOcorrenciaInadimplencia.View'

export const SemOcorrenciaInadimplencia = composeIO(SemOcorrenciaInadimplenciaView, semOcorrenciaInadimplenciaIO)
